import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store, persistor } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Navigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import callIcon from "assets/images/public-pages/orange-call.svg";
import emailIcon from "assets/images/public-pages/purple-email.svg";
import locationIcon from "assets/images/public-pages/blue-location-icon.svg";
import PteConsultation from "components/PublicPagesReusable/PteConsultation";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import ContactUs from "components/PublicPagesReusable/ContactUs";

function Contact(props) {
  const [flag, setFlag] = useState(false);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search); 
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

   const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
         Let's Make Your<br/>
        <span className="fw-600 text-success">Learning Meaningful.</span>
        {/* <br /> */}
      </h1>
    );
  };

     const heroData = {
    badge: "We Reply Within 24 Hours",
    title: heroWorkTitle,
    subtitle: "Feel free to contact us if you need some help, consultation or you have some other questions.",
    // profile: {
    //   image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
    //   stats: [
    //     { value: "10K+", label: "Students" },
    //     { value: "85%", label: "First-Attempt Success" },
    //     { value: "4.8★", label: "Google Rating" }
    //   ]
    // },
    bottomStats: [
      {highlight: 'Call US', grayLabel: "Speak to Our Team", icon: callIcon, cardValue:"+61 426 230 061",subText:"Mon–Fri : 10am–7pm AEDT<br/>Sat–Sun : 10am–5pm AEDT",link:"tel:+61426230061",btnText:"Call Now",imgWidth:"44px",imgHeight:"44px"  },
      {highlight: 'EMAIL US', grayLabel: "Send a Message", icon: emailIcon, cardValue:"info@languageacademy.com.au",subText:"Reply within 24 hours",link:"mailto:info@languageacademy.com.au",btnText:"Email Us",imgWidth:"44px",imgHeight:"44px"  },
      {highlight: 'Visit US', grayLabel: "Come Say Hi", icon: locationIcon, link: () => window.open("https:\/\/goo.gl\/maps\/fBXRyJt6jdukuzQs8", "_blank"),btnText:"Get Direction",subGrayText:"46 George Street,Parramatta NSW 2150, Australia",imgWidth:"44px",imgHeight:"44px"  }
    ]
  };

  const faqQuestions = [
  {
    question: "How quickly will I get a response after sending my inquiry?",
    answer: "Our team typically responds within 24 hours during business hours — because we know your time matters. You can also reach us directly on +61 426 230 061, Mon to Fri : 10am–7pm AEDT, Sat to Sun : 10am–5pm AEDT, if you'd prefer to just talk it through."
  },
  {
    question: "What courses does LA Language Academy offer?",
    answer: "We specialise in PTE Academic, PTE Core, IELTS, and NAATI CCL preparation — each designed to get you to your target score as efficiently as possible. Whether you're looking for video courses, live coaching, or AI-powered mock test practice, we have the right pathway for you."
  },
  {
    question: "Can I speak to someone before I decide to enroll?",
    answer: " Absolutely — that's exactly what we're here for. Fill in the form above or give us a call, and one of our team will walk you through which course and package best fits your goals, timeline, and current level"
  },
  {
    question: "Do you offer online classes as well as in-person coaching?",
    answer: "Yes — we offer both. Our online platform gives you access to video lessons, AI practice tools, and live coaching from anywhere in the world. If you're interested in in-person coaching, you're also welcome to visit us at any of our branches in Australia, Nepal and India."
  },
   {
    question: "I'm not sure which course is right for me. Where do I start?",
    answer: " Start right here! Drop us a message using the form above — just share your target exam, your current score (if you have one), and your timeline. Our team will come back to you with a personalized recommendation."
  },
   {
    question: "What makes LA Language Academy different from other test prep providers?",
    answer: " Our courses are built on real, proven expertise — not just theory. Our lead trainer, Varun Dhawan, has achieved a perfect 90 score in PTE Academic 14 times, making LA one of the most credible test prep providers in Australia. You're learning from mastery, and that makes all the difference."
  }
];

  return (
    <>
      <Helmet>
        <title>Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes</title>
        <meta name="description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/contact`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes" />
        <meta name="twitter:description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/contact`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes" />
        <meta property="og:description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design contact">
        <Header />
        <NocBanner data={heroData} extraClass={"contact-hero-section"} extraClass2={"align-items-start text-start"} top={"65%"}/>
        <div className="py-0 py-lg-5">
          <ContactUs/>
        </div>
          <div className="custom-container">
             <section className="naati-hero-section bottom-section-radius">
            <div className="px-3 px-md-4 px-lg-5 hero-container py-5">
              <div className="row align-items-center g-5">

                {/* Left side - Text + Stats */}
                <div className="col-lg-6 text-center text-lg-start py-3 py-lg-2">

                  <p className="top-section-text FS56FW500 mb-4">
                    Easy <span className="text-success FS40FW600">Mobile Access</span>
                  </p>

                  <p className="lead-text FS20FW500 mb-4">
                    Don't let a busy lifestyle delay your Australian permanent residency dreams or global opportunities.
                  </p>
                  <p className="lead-text FS20FW500 mb-4">
                  Download the Language Academy apps today and Join 50K+ of successful students' who've earned their goals through smart, flexible preparation.
                  </p>

                  <div className="download-buttons mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_NAATI_ANDROID_APP_URL}>
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_NAATI_IOS_APP_URL}>
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  </div>

                  <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                    <div className="avatars d-flex">
                      <img src="/images/web-new-images/new-content-slider/User-01.svg" alt="user" className="avatar rounded-circle" />
                      <img src="/images/web-new-images/new-content-slider/User-02.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/User-03.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/RamimRahman-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                    </div>
                    <span className="join-text FS20FW500 fw-600">Join 50K+ Students'</span>
                  </div>
                </div>

                {/* Right side - Phones mockup */}
                <div className="col-lg-6">
                  <div className="phones-container position-relative text-center">
                    <img
                      src="/images/web-new-images/HomePageImage/PTE-app-1.png"
                      alt="NAATI CCL App - Mock Test"
                      className="img-fluid"
                    />
                  </div>
                </div>

              </div>
            </div>
          </section>
          </div>
         <div className="pt-5">
             <FaqSection questions={faqQuestions} />
         </div>
       
        <Footer />
      </div>
    </>
  );
}

export default Contact;
